export const CALLBACK_MODES = {
  oneToOne: 'one_to_one',
  webinar: 'webinar',
};

export const QUERY_PARAMS = {
  openCalendly: 'open-calendly',
  requestCallback: 'request-callback',
};

export const PROGRAM_PAGE_URL = {
  'program-data-science': [
    'courses/data-science-machine-learning-course',
  ],
  'program-software-developer': [
    'courses/data-structures-and-algorithms',
  ],
};
